import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { ListPostOptions, Post, PostPriority, PostStatus } from '@eview/core/domain/post/post';
import { User } from '@eview/core/models/user';
import { GetLinkedPostsData } from '@eview/core/store/actions/posts.actions';
import { selectUser } from '@eview/core/store/selectors/user.selector';
import { AppState } from '@eview/core/store/states/app.state';
import { selectForms } from '@eview/core/store/selectors/forms.selector';
import { Form } from '@eview/core/domain/form/form';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  ECustomActions,
  ShowPostDetail,
  UpdatedPost
} from '../../custom.store';
import { PostHelpers } from '@eview/core/domain/post/post.helpers';

@Component({
  selector: 'eview-post',
  templateUrl: 'post.component.html',
  styleUrls: ['post.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostComponent implements OnInit, OnDestroy {
  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private cdr: ChangeDetectorRef
  ) {
    this.subs = new Subscription();
    this.activePostId$ = this.actions$.pipe(
      ofType<ShowPostDetail>(ECustomActions.ShowPostDetail),
      map(action => (action.payload ? action.payload.id : null))
    );
    this.active$ = this.activePostId$.pipe(
      map(id => id === this.post.id)
    );
    this.user$ = this.store.select(selectUser);
  }

  ngOnInit() {
    this.subs.add(
      this.store.select(selectForms).subscribe(forms => {
        this.formsCatalog = forms?.results ? [...forms.results] : [];
        this.cdr.markForCheck();
      })
    );
    this.subs.add(
      this.actions$
        .pipe(ofType<UpdatedPost>(ECustomActions.UpdatedPost))
        .subscribe(action => {
          this.post =
            action.payload.id === this.post.id ? action.payload : this.post;
          this.cdr.markForCheck();
        })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  @Input() public post: Post;
  @Output() public onShowLinkedPostClick: EventEmitter<Object> = new EventEmitter();

  PostPriority = PostPriority;
  readonly PostHelpers = PostHelpers;

  /** Used only for display when post has no title (list payloads may omit `form.name`). */
  private formsCatalog: Form[] = [];

  get displayTitle(): string {
    return PostHelpers.GetPostDisplayTitle(this.post, this.formsCatalog);
  }

  activePostId$: Observable<number>;
  active$: Observable<boolean>;

  private subs: Subscription;

  user$: Observable<User>;

  onClick() {
    this.store.dispatch({
      type: ECustomActions.ShowPostDetail,
      payload: this.post
    });
    const payload:ListPostOptions={
      status: PostStatus.All,
      offset: 0,
      parent: this.post.id.toString()
    };
    this.store.dispatch(new GetLinkedPostsData(payload));
  }

  onShowLinkedClick(post: Post) {
    event.stopPropagation();
    this.onShowLinkedPostClick.emit({
      id: post.id,
      title: PostHelpers.GetPostDisplayTitle(post, this.formsCatalog)
    });
  }
}
